import { useState, useEffect } from "react";
import axios from "axios";



const UploadExcel = () => {
  const [file, setFile] = useState(null);
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState("");
  const [message, setMessage] = useState("");


  useEffect(() => {
    const fetchClients = async () => {
      try {
        const res = await axios.get("http://localhost:8000/client/get-client");
        setClients(res.data);
      } catch (err) {
        console.error("Failed to fetch clients:", err);
      }
    };
    fetchClients();
  }, []);



  const handleUpload = async () => {
    if (!file) return alert("Select a file!");
    if (!selectedClientId) return alert("Select a client!");

    const formData = new FormData();
    formData.append("file", file);
    formData.append("clientId", selectedClientId);

    try {
      const res = await axios.post("http://localhost:8000/excel/upload", formData);
      setMessage(res.data.message);
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || "Upload failed!");
    }
  };


  return (
    <div style={{ padding: "20px", maxWidth: "400px" }}>
      <h2>Upload Excel</h2>

      <select
        value={selectedClientId}
        onChange={(e) => setSelectedClientId(e.target.value)}
        style={{ width: "100%", marginBottom: "10px", padding: "8px" }}
      >
        <option value="">Select Client</option>
        {clients.map((client) => (
          <option key={client.id} value={client.id}>
            {client.clientName} 
          </option>
        ))}
      </select>

      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={(e) => setFile(e.target.files[0])}
        style={{ width: "100%", marginBottom: "10px" }}
      />

      <button onClick={handleUpload} style={{ width: "100%", padding: "10px" }}>
        Upload
      </button>

      {message && <div style={{ marginTop: "10px" }}>{message}</div>}
    </div>
  );
}

export default UploadExcel;


